import { useState } from 'react';
import PageHero from '../components/PageHero';

const WHO = [
  { icon:'🌾', label:'Farmers & Agricultural Workers', sub:'किसान' },
  { icon:'👩‍🎓', label:'Students & Young Adults', sub:'विद्यार्थी' },
  { icon:'🏠', label:'Families Seeking Housing', sub:'आवास-जरूरतमंद परिवार' },
  { icon:'👵', label:'Senior Citizens', sub:'वरिष्ठ नागरिक' },
  { icon:'🧑‍🔧', label:'Self-Employed & Artisans', sub:'स्वरोज़गार' },
  { icon:'🏥', label:'Below Poverty Line Households', sub:'BPL परिवार' },
];

const CENTRAL_CATS = [
  { icon:'🌾', title:'Agriculture',       sub:'कृषि',             schemes:['PM-Kisan Samman Nidhi','Soil Health Card Scheme','PM Fasal Bima Yojana','Kisan Credit Card'] },
  { icon:'🏠', title:'Housing',           sub:'आवास',              schemes:['PM Awas Yojana (Urban)','PM Awas Yojana (Rural)','Rajiv Gandhi Awas Yojana'] },
  { icon:'📚', title:'Education',         sub:'शिक्षा',             schemes:['PM Scholarship Scheme','Sukanya Samriddhi Yojana','National Scholarship Portal'] },
  { icon:'🏥', title:'Health',            sub:'स्वास्थ्य',          schemes:['Ayushman Bharat PM-JAY','PM Suraksha Bima Yojana','Janani Suraksha Yojana'] },
  { icon:'💼', title:'Employment',        sub:'रोज़गार',            schemes:['MGNREGS','PM SVANidhi','PM Rojgar Protsahan Yojana'] },
  { icon:'👵', title:'Social Protection', sub:'सामाजिक सुरक्षा',   schemes:['Atal Pension Yojana','National Social Assistance Programme','PM Jeevan Jyoti Bima'] },
];

const STATE_SCHEMES = {
  'Uttar Pradesh': {
    hindi: 'उत्तर प्रदेश',
    schemes: [
      { icon:'👧', title:'Kanya Sumangala Yojana', sub:'कन्या सुमंगला योजना',     desc:'₹15,000 support for girl child from birth to graduation' },
      { icon:'🌾', title:'UP Kisan Karj Rahat',    sub:'किसान कर्ज राहत',          desc:'Farm loan waiver up to ₹1 lakh for small & marginal farmers' },
      { icon:'🏗️', title:'UP Awas Vikas Yojana',   sub:'आवास विकास योजना',         desc:'Affordable housing schemes for EWS and LIG categories' },
      { icon:'💼', title:'UP Startup Policy',       sub:'स्टार्टअप नीति',            desc:'Seed funding & incubation support for UP-based startups' },
    ],
  },
  'Maharashtra': {
    hindi: 'महाराष्ट्र',
    schemes: [
      { icon:'👩‍🌾', title:'Magel Tyala Shet Tale',  sub:'मागेल त्याला शेत तळे',     desc:'Individual farm pond for water conservation — subsidy up to ₹50,000' },
      { icon:'🏠', title:'Ramai Awas Yojana',        sub:'रमाई आवास योजना',          desc:'Free housing for SC/NT/OBC/SBC category households' },
      { icon:'📚', title:'EBC Scholarship',          sub:'EBC शिष्यवृत्ति',           desc:'Full fee waiver for students with family income below ₹8 lakh' },
      { icon:'💊', title:'Mahatma Phule Jan Arogya', sub:'महात्मा फुले जन आरोग्य',   desc:'Cashless treatment up to ₹5 lakh in govt & empanelled hospitals' },
    ],
  },
  'Rajasthan': {
    hindi: 'राजस्थान',
    schemes: [
      { icon:'🏥', title:'Chiranjeevi Swasthya Bima',sub:'चिरंजीवी स्वास्थ्य बीमा',  desc:'Free medical insurance up to ₹25 lakh per family per year' },
      { icon:'📱', title:'Free Mobile Yojana',        sub:'फ्री मोबाइल योजना',         desc:'Free smartphone with 3 years internet for women heads of household' },
      { icon:'🌊', title:'Mukhyamantri Jal Swavlamban', sub:'जल स्वावलंबन',           desc:'Watershed development — financial aid for water harvesting' },
      { icon:'🌾', title:'Bhamashah Krishi Bima',     sub:'भामाशाह कृषि बीमा',        desc:'State crop insurance — covers drought, flood, hailstorm' },
    ],
  },
  'Madhya Pradesh': {
    hindi: 'मध्य प्रदेश',
    schemes: [
      { icon:'👰', title:'Ladli Laxmi Yojana',       sub:'लाडली लक्ष्मी योजना',      desc:'₹1.43 lakh education bond for girl child registered at birth' },
      { icon:'🌾', title:'Mukhyamantri Kisan Kalyan', sub:'मुख्यमंत्री किसान कल्याण', desc:'Additional ₹4,000/year on top of PM-Kisan for MP farmers' },
      { icon:'🏠', title:'Mukhyamantri Awas Yojana', sub:'मुख्यमंत्री आवास योजना',    desc:'Pucca house construction support for homeless families' },
      { icon:'💼', title:'Yuva Udyami Yojana',        sub:'युवा उद्यमी योजना',         desc:'Loan up to ₹10 lakh at 5% interest for youth entrepreneurs' },
    ],
  },
  'Gujarat': {
    hindi: 'गुजरात',
    schemes: [
      { icon:'⚡', title:'Kisan Suryoday Yojana',    sub:'किसान सूर्योदय योजना',      desc:'3-phase electricity supply to farmers from 5 AM to 9 PM' },
      { icon:'💧', title:'Sujalam Sufalam Yojana',   sub:'सुजलाम सुफलाम योजना',       desc:'Water supply network connecting Narmada to Northern Gujarat' },
      { icon:'📚', title:'Vidya Sahay Yojana',       sub:'विद्या सहाय योजना',          desc:'Contract teaching positions for unemployed educated youth' },
      { icon:'🏭', title:'MSME Sahay Yojana',        sub:'MSME सहाय योजना',           desc:'Collateral-free loans for micro & small enterprises' },
    ],
  },
  'Karnataka': {
    hindi: 'कर्नाटक',
    schemes: [
      { icon:'🚌', title:'Shakti Free Bus Pass',      sub:'शक्ति फ्री बस',              desc:'Free KSRTC & BMTC bus travel for all women across Karnataka' },
      { icon:'📚', title:'Anna Bhagya Scheme',        sub:'अन्न भाग्य',                  desc:'10 kg free rice per month per person for BPL families' },
      { icon:'💰', title:'Gruha Jyothi',              sub:'गृह ज्योति',                  desc:'First 200 units of electricity free for all domestic consumers' },
      { icon:'👨‍💼', title:'Yuva Nidhi',               sub:'युव निधि',                    desc:'₹3,000/month unemployment allowance for graduates for 2 years' },
    ],
  },
};

const ALL_STATES = Object.keys(STATE_SCHEMES);

export default function ForCitizens({ go }) {
  const [mainTab,      setMainTab]      = useState('CENTRAL');
  const [selectedState, setSelectedState] = useState('Uttar Pradesh');

  const stateData = STATE_SCHEMES[selectedState];

  return (
    <>
      <PageHero tag="For Citizens · नागरिकों के लिए" title="The Right Scheme for Every Situation" subtitle="हर परिस्थिति के लिए सही योजना" from="#000080" to="#1a1a99" />

      <section className="section section-gray">
        <div className="wrap">
          {/* Intro + who uses */}
          <div className="cit-top">
            <div>
              <p className="cit-desc">Whether you need income support, education, healthcare, or housing — YojanaSaathi matches your exact situation to the schemes built for it. We cover central and state-specific schemes in all 28 states.</p>
              <ul className="checklist">
                {['Matched on real eligibility criteria — not keyword search','Central and state schemes in one place','Track every application status in one dashboard','Health, education, housing, agriculture — all sectors','Available in Hindi and English'].map(t=>(
                  <li key={t}><span className="tick" style={{color:'#FF9933'}}>✓</span>{t}</li>
                ))}
              </ul>
              <div className="cit-cta">
                <button className="btn btn-navy" onClick={()=>go('contact')}>Find My Schemes — It's Free →</button>
              </div>
            </div>

            <div className="info-box">
              <div className="info-box-title" style={{color:'#000080'}}>Who Uses YojanaSaathi</div>
              {WHO.map(u=>(
                <div key={u.label} className="info-row">
                  <span className="icon">{u.icon}</span>
                  <div><div className="label">{u.label}</div><div className="sub">{u.sub}</div></div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Tab header ─────────────────────────────────────────────────── */}
          <div style={{ marginTop: 52 }}>
            <div style={{ display:'flex', borderBottom:'2px solid var(--border)', marginBottom: 32 }}>
              {[
                { key:'CENTRAL', label:'🏛️ Central Schemes', sub:'केंद्र सरकार', color:'#000080' },
                { key:'STATE',   label:'🗺️ State Schemes',   sub:'राज्य सरकार',  color:'#7c3aed' },
              ].map(tab => (
                <button
                  key={tab.key}
                  onClick={() => setMainTab(tab.key)}
                  style={{
                    padding: '12px 28px', background:'none', border:'none', cursor:'pointer',
                    fontWeight: 700, fontSize: 15,
                    color: mainTab === tab.key ? tab.color : 'var(--text-lt)',
                    borderBottom: mainTab === tab.key ? `3px solid ${tab.color}` : '3px solid transparent',
                    marginBottom: -2,
                    display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2,
                  }}
                >
                  {tab.label}
                  <span style={{ fontSize: 10, fontWeight: 600, color: mainTab === tab.key ? tab.color : 'var(--text-lt)', opacity: 0.8 }}>{tab.sub}</span>
                </button>
              ))}
            </div>

            {/* ── CENTRAL tab ──────────────────────────────────────────────── */}
            {mainTab === 'CENTRAL' && (
              <>
                <div className="cat-header">
                  <span className="tag" style={{color:'#000080'}}>
                    <span className="tag-bar" style={{background:'#000080'}}/>
                    Scheme Categories · योजना श्रेणियाँ
                    <span className="tag-bar" style={{background:'#000080'}}/>
                  </span>
                </div>
                <div className="cat-grid">
                  {CENTRAL_CATS.map(cat=>(
                    <div key={cat.title} className="cat-card">
                      <div className="cat-icon">{cat.icon}</div>
                      <h4>{cat.title}</h4>
                      <div className="cat-sub">{cat.sub}</div>
                      <ul>{cat.schemes.map(s=><li key={s}>{s}</li>)}</ul>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* ── STATE tab ────────────────────────────────────────────────── */}
            {mainTab === 'STATE' && (
              <>
                {/* State selector */}
                <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:32, flexWrap:'wrap' }}>
                  <span className="tag" style={{color:'#7c3aed'}}>
                    <span className="tag-bar" style={{background:'#7c3aed'}}/>
                    Select Your State · अपना राज्य चुनें
                    <span className="tag-bar" style={{background:'#7c3aed'}}/>
                  </span>
                  <div style={{ position:'relative' }}>
                    <select
                      value={selectedState}
                      onChange={e => setSelectedState(e.target.value)}
                      style={{
                        appearance:'none', padding:'10px 36px 10px 14px',
                        border:'2px solid #7c3aed', borderRadius: 8,
                        fontWeight:700, fontSize:14, color:'#7c3aed',
                        background:'#7c3aed0d', cursor:'pointer', outline:'none',
                      }}
                    >
                      {ALL_STATES.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                    <span style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', pointerEvents:'none', color:'#7c3aed', fontSize:12 }}>▾</span>
                  </div>
                  {stateData && (
                    <span style={{ fontSize:13, color:'var(--text-lt)', fontStyle:'italic' }}>
                      {stateData.hindi}
                    </span>
                  )}
                </div>

                {/* State scheme cards */}
                {stateData && (
                  <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(260px, 1fr))', gap:20 }}>
                    {stateData.schemes.map(s => (
                      <div key={s.title} className="card" style={{ borderTop:'4px solid #7c3aed', padding:'22px 20px' }}>
                        <div style={{ fontSize:28, marginBottom:10 }}>{s.icon}</div>
                        <h4 style={{ fontFamily:'Georgia,serif', fontSize:16, color:'var(--text)', marginBottom:4 }}>{s.title}</h4>
                        <div style={{ fontSize:11, color:'#7c3aed', fontWeight:700, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:10 }}>{s.sub}</div>
                        <p style={{ fontSize:13.5, color:'var(--text-md)', lineHeight:1.6 }}>{s.desc}</p>
                      </div>
                    ))}
                  </div>
                )}

                {/* More states note */}
                <div style={{
                  marginTop:36, padding:'20px 24px', background:'linear-gradient(135deg,#7c3aed0d,#000080 0d)',
                  borderRadius:12, border:'1px solid #7c3aed30',
                  display:'flex', alignItems:'center', gap:16, flexWrap:'wrap',
                }}>
                  <span style={{ fontSize:28 }}>🗺️</span>
                  <div>
                    <div style={{ fontWeight:700, color:'#7c3aed', fontSize:15 }}>More states being added continuously</div>
                    <div style={{ fontSize:13, color:'var(--text-md)', marginTop:3 }}>
                      Download the app to see all schemes for your exact state, district & profile — including schemes not listed here.
                    </div>
                  </div>
                  <button className="btn btn-outline" style={{ color:'#7c3aed', borderColor:'#7c3aed', fontSize:13, marginLeft:'auto' }} onClick={()=>go('contact')}>
                    Get Notified →
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}